import { Container, CssBaseline } from "@mui/material";

const Layout = ({ children }) => {
  return (
    <div>
      <CssBaseline />
      <Container
        maxWidth="xl"
        style={{ paddingTop: "20px", paddingBottom: "5px" }}
      >
        {/* Header */}
        <header>{/* You can place your app's header content here */}</header>

        {/* Main content */}
        <main>{children}</main>

        {/* Footer */}
        <footer>{/* You can place your app's footer content here */}</footer>
      </Container>
    </div>
  );
};

export default Layout;
